export default __webpack_public_path__ + "static/media/screenone.18a7291d.jpg";